import { Component, Input, Output, EventEmitter } from '@angular/core';

import { SelectorOption } from './generic-selector.component';

export type SourceType = 'solar' | 'grid' | 'battery' | 'home' | 'irradiance' | 'panelTemperature';

const SOURCE_OPTIONS: Record<SourceType, SelectorOption> = {
  solar: {
    id: 'solar',
    iconActive: 'cmp-assets/solar.svg',
    iconInactive: 'cmp-assets/solar-off.svg',
    activeClass: 'bg-orange-100',
  },
  grid: {
    id: 'grid',
    iconActive: 'cmp-assets/grid.svg',
    iconInactive: 'cmp-assets/grid-off.svg',
    activeClass: 'bg-grey-100',
  },
  battery: {
    id: 'battery',
    iconActive: 'cmp-assets/battery.svg',
    iconInactive: 'cmp-assets/battery-off.svg',
    activeClass: 'bg-green-100',
  },
  home: {
    id: 'home',
    iconActive: 'cmp-assets/home.svg',
    iconInactive: 'cmp-assets/home-off.svg',
    activeClass: 'bg-blue-100',
  },
  irradiance: {
    id: 'irradiance',
    iconActive: 'cmp-assets/irradiance.svg',
    iconInactive: 'cmp-assets/irradiance-off.svg',
    activeClass: 'bg-yellow-100',
  },
  panelTemperature: {
    id: 'panelTemperature',
    iconActive: 'cmp-assets/temperature.svg',
    iconInactive: 'cmp-assets/temperature-off.svg',
    activeClass: 'bg-red-100',
  },
};

@Component({
  selector: 'app-custom-source-selector',
  templateUrl: './custom-source-selector.component.html',
  styleUrls: ['./custom-source-selector.component.scss'],
})
export class CustomSourceSelectorComponent {
  @Input() source: SourceType[] = ['solar'];
  @Input() options: SourceType[] = ['solar', 'grid', 'battery', 'home'];
  @Input() mode: 'single' | 'multiple' = 'multiple';
  @Output() selection = new EventEmitter<SourceType[]>();

  get selectorOptions(): SelectorOption[] {
    return this.options.map((opt) => SOURCE_OPTIONS[opt]);
  }

  onSelection(selected: string[]) {
    this.selection.emit(selected as SourceType[]);
  }
}
